<template>
  <div>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  created () {
    let origin = 'web'
    if (this.$q.platform.is.desktop) {
      origin = 'web/desktop'
    } else {
      origin = 'web/mobile'
    }
    this.$store.dispatch('refreshToken', origin)
    // if (axios.defaults.headers.common['Token'] !== '') {
    //   this.$store.dispatch('getAllRooms')
    //   let source = new EventSource(`${axios.defaults.baseURL}platform/emitter/sse/${axios.defaults.headers.common['Token']}`)
    //   source.addEventListener('open', e => {
    //     console.log('Conectado')
    //   }, false)
    //   source.onmessage = event => {
    //     let message = JSON.parse(event.data)
    //     this.$store.commit('emitterUpdateMsg', message.content)
    //   }
    //   source.onerror = event => {
    //     console.log(event)
    //   }
    // }
  }
}
</script>

<style>
</style>
